<template>
<v-simple-table fixed-header height="100%">
    <template v-slot:default>
        <thead>
            <tr>
                <th class="text-left">Usuario</th>
                <th class="text-left">Rol</th>
                <th class="text-left">Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in roles" :key="item.id">
                <td>{{ item.usuario }} - {{item.id}}</td>
                <td>{{ item.rol }}</td>
                <td>

                    <v-dialog v-model="dialog" scrollable max-width="300px">
                        <template v-slot:activator="{ on }">
                            <v-icon small class="mr-2" @click="cambiarRol(item)" v-on="on">mdi-pencil</v-icon>
                        </template>
                        <v-form ref="form" @submit.prevent="editarUserRoles(rol)">
                            <v-card max-width="300px">
                                <v-card-title>Selecciona un Rol</v-card-title>
                                <v-divider></v-divider>
                                <v-card-text style="height: 300px;">
                                    <v-radio-group v-model="rol.rol" column>
                                        <v-radio label="Solicitar" value="SOLICITAR"></v-radio>
                                        <v-radio label="Revisar" value="REVISAR"></v-radio>
                                        <v-radio label="Recoger" value="RECOGER"></v-radio>
                                        <v-radio label="Abonar" value="ABONAR"></v-radio>
                                        <v-radio label="Administrador" value="ADMIN"></v-radio>
                                    </v-radio-group>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                                    <v-btn color="blue darken-1" text @click="dialog = false" type="submit">Guardar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-dialog>
                </td>
            </tr>
        </tbody>
    </template>

</v-simple-table>
</template>

<script>
import {
    mapActions,
    mapState
} from 'vuex'

export default {
    name: 'Roles',
    data() {
        return {
            rol: {
                id: '',
                rol: ''
            },
            dialog: false,
        }
    },
    computed: {
        ...mapState(['roles'])
    },
    created() {
        this.getUserRoles()
    },
    methods: {
        ...mapActions(['getUserRoles', 'editarUserRoles', 'eliminarUsuario']),
        cambiarRol(rol) {
            this.rol.id = rol.id;
            this.rol.rol = rol.rol;
            this.dialog = true;
        },
    },
}
</script>
